import { CardMediaPill } from '@app/components/base/CardMediaPill';
import { UploadedPlatformsStatus } from '@app/components/base/UploadedPlatformsStatus';
import type { webApi } from '@mi-front/api-clients';
import { Box } from '@mui/material';
import { getDisplayPlatformItems } from '../../../list/fragment-card/base/FragmentCardStatuses';
import { ProjectCardMediaPlaceholder } from './ProjectCardMediaPlaceholder';
import { ProjectCardRenderStatus } from './ProjectCardRenderStatus';
import { ProjectCardThumbnail } from './ProjectCardThumbnail';

export interface ProjectCardMediaAreaProps {
  thumbnailSrc: string | null;
  renderJob: webApi.EnrichedVideoEditorProjectListItemDto['renderJob'];
  publishedPlatforms: webApi.EnrichedVideoEditorProjectListItemDto['publishedPlatforms'];
}

/**
 * Top of the card: thumbnail or empty placeholder; top-right shows either upload platform
 * statuses (when there is a completed/failed publish to show) or render job / “Sin generar”.
 */
export function ProjectCardMediaArea({
  thumbnailSrc,
  renderJob,
  publishedPlatforms,
}: ProjectCardMediaAreaProps) {
  const platformItems = getDisplayPlatformItems({
    uploadStatuses: [],
    publishedPlatforms,
  });

  const hasPublishedPlatformStatuses = platformItems.length > 0;

  return (
    <Box sx={{ position: 'relative', flexShrink: 0 }}>
      {thumbnailSrc ? <ProjectCardThumbnail src={thumbnailSrc} /> : <ProjectCardMediaPlaceholder />}
      <Box
        sx={{
          position: 'absolute',
          zIndex: 1,
          top: 8,
          right: 8,
          maxWidth: 'calc(100% - 16px)',
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        {hasPublishedPlatformStatuses ? (
          <CardMediaPill>
            <UploadedPlatformsStatus variant="pill" size="medium" items={platformItems} />
          </CardMediaPill>
        ) : (
          <ProjectCardRenderStatus renderJob={renderJob} />
        )}
      </Box>
    </Box>
  );
}
